<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <table class="table table-sm table-hover table-striped">
                <thead>
                    <th>
                        العميل
                    </th>
                    <th>
                        الاجهزة
                    </th>
                    <th>
                        الطلبات
                    </th>
                    <th>
                        الاوامر المعلقة
                    </th>
                    <th>
                        خيارات
                    </th>
                </thead>
                <tbody>
                    <tr v-for="u in users" :key="u._id">
                        <td>
                            {{ u.name }}
                        </td>
                        <td>
                            {{ u.devices }}
                        </td>
                        <td>
                            {{ u.orders }}
                        </td>
                        <td>
                            {{ u.requests }}
                        </td>
                        <td>
                            <button class="btn btn-primary" v-b-modal.edit @click="current = u" style="padding: 3px">
                                <i class="fa fa-edit"></i>
                            </button>
                            &nbsp;
                            <button class="btn btn-sm btn-danger" style="padding: 3px" @click="deleteAccount(u._id)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <b-modal id="edit" title="تعديل" hide-footer>
        <template v-if="current._id">
            <div class="form-group">
              <label for="">رقم الجوال</label>
              <input type="text"
                class="form-control" v-model="current.phone">
            </div>
            <div class="form-group">
              <label for="">كلمة المرور</label>
              <input type="text"
                class="form-control" v-model="current.password">
            </div>
            <button class="btn btn-block btn-primary" @click="join()">
                <i class="fa fa-external-link"></i>
                دخول بحسابه
            </button>
        </template>
    </b-modal>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            users: [],
            current: {}
        }
    },
    created(){
        var g = this;
        $.post(api + '/admin/users', {
            jwt: this.user.jwt
        }).then(function(r){
            g.users = r.response;
        })
    },
    methods: {
        gett(){
            var g = this;
        },
        deleteAccount(id){
            if(confirm("متأكد من حذف الحساب نهائيا؟")){
                var g = this;
                $.post(api + '/admin/users/delete', {
                    jwt: this.user.jwt,
                    id: id
                }).then(function(r){
                    location.reload()
                })
            }
        },
        join(){
            window.open(`https://zatca.brmja.com/?jwt=${this.current.jwt}&name=${this.current.name}`)
        }
    }
}
</script>

<style>

</style>